/************************************
 MODULE:         find a store popup
 WHAT IT DOES:   initializes find a store popup for mobiles
 *************************************/
(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        define(['jquery'], factory);
    }
    else if (typeof exports === 'object') {
        module.exports = factory(require('jquery'));
    }
    else { root.returnExports = factory(root.jQuery); }
}(this, function ($) {

    var tweenmax, tween, opener, closer, popup, html, main;

    function init() {

        html = $('html');
        main = $('.js-main');
        opener = $('.js-fas-opener');
        closer = $('.js-fas-closer');
        popup = $('.js-fas-popup-container .js-fas-popup');
        tweenmax = require('tweenmax');
        tween = new TimelineMax({onComplete: animationComplete});

        if (!opener.length || !popup.length)
            return;

        $(window).on('resize:finished', resize);
        resize();
    }

    function clickProcess(e) {
        if (typeof e != 'undefined' && typeof e.preventDefault == 'function') {
            e.preventDefault();
        }

        if (popup.hasClass('is-popup-process')) {
            return;
        }

        if (popup.hasClass('is-popup-opened')) {
            close();
        }
        else {
            open();
        }

        popup.addClass('is-popup-process');

    }

    function open() {
        tween.fromTo(popup, 0.3, { left: "-100%" }, { left: 0 });
        tween.play();
        popup.addClass('is-popup-opened');
        html.addClass('fas-popup-opened');
    }

    function close() {
        tween.fromTo(popup, 0.3, { left: "0" }, { left: "-100%" });
        tween.play();
        popup.removeClass('is-popup-opened');
        html.removeClass('fas-popup-opened');
    }

    function animationComplete() {
        popup.removeClass('is-popup-process');
    }

    function resize() {
        if (window.App.globals.isTabletSmall) {
            opener.on('click.popup', clickProcess);
            closer.on('click.popup', clickProcess);
        }
        else {
            opener.off('click.popup');
            closer.off('click.popup');
        }
    }

    return {
        init: init
    };

}));


/*****************
 ** WEBPACK FOOTER
 ** ./js/app/modules/app.faspopup.js
 ** module id = 38
 ** module chunks = 24
 **/